/**
 * Supported features by thi APP
 */
export enum Feature {
  ACCOUNTS,
  SYSTEM_INFO,
  DATE_TIME,
  NETWORK,
  VOIP,
  MAINTENANCE,
  DIAGNOSTICS,
  LICENSES,
  ACCESS_CONTROL,
  DEVICE,
  IP_CAMERAS,
  XIP_SYSTEM,
  XIP_PABX,
  VOICEMAIL,
  DASHBOARD,
}

/**
 * Feature property
 */
export type FeatureProperty = {
  /**
   * Feature unique name. The string which identifies the feature (see openapi YAML file)
   * It is also used as query parameter to access to ui-info api
   */
  featureId: string;
  /**
   * Relative address of the feature on this application
   */
  appAddress: string;
};

type FeatureConfiguration = Record<keyof typeof Feature, FeatureProperty>;

/**
 * Configuration of the properties of each feature
 */
export const featuresConfiguration: FeatureConfiguration = {
  ACCOUNTS: {
    featureId: 'accounts',
    appAddress: 'accounts',
  },
  SYSTEM_INFO: {
    featureId: 'systeminfo',
    appAddress: 'systeminfo',
  },
  DATE_TIME: {
    featureId: 'datetime',
    appAddress: 'datetime',
  },
  NETWORK: {
    featureId: 'network',
    appAddress: 'network',
  },
  VOIP: {
    featureId: 'VOIP',
    appAddress: 'voip',
  },
  MAINTENANCE: {
    featureId: 'maintenance',
    appAddress: 'maintenance',
  },
  DIAGNOSTICS: {
    featureId: 'diagnostics',
    appAddress: 'diagnostics',
  },
  LICENSES: {
    featureId: 'licenses',
    appAddress: 'licenses',
  },
  ACCESS_CONTROL: {
    featureId: 'accesscontrol',
    appAddress: 'accesscontrol',
  },
  DEVICE: {
    featureId: 'device',
    appAddress: 'device',
  },
  IP_CAMERAS: {
    featureId: 'ip_cameras',
    appAddress: 'ip_cameras',
  },
  XIP_SYSTEM: {
    featureId: 'xip-system',
    appAddress: 'xip-system',
  },
  XIP_PABX: {
    featureId: 'xippabx',
    appAddress: 'xippabx',
  },
  VOICEMAIL: {
    featureId: 'voicemail',
    appAddress: 'voicemail',
  },
  DASHBOARD: {
    featureId: 'sites',
    appAddress: 'sites',
  },
};
